var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 13.8332C3.40033 13.8332 3.16699 13.7332 2.96699 13.5332C2.76699 13.3332 2.66699 13.0998 2.66699 12.8332V10.4498H3.66699V12.8332H12.3337V10.4498H13.3337V12.8332C13.3337 13.0998 13.2337 13.3332 13.0337 13.5332C12.8337 13.7332 12.6003 13.8332 12.3337 13.8332H3.66699ZM7.50033 11.2832V5.09984L8.21667 5.21667L7.5 5L8 5.18133L8.5 5L7.78333 5.71667L8.50033 5.09984V11.2832H7.50033Z",
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7524_30488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 1.16683C3.40033 1.16683 3.16699 1.26683 2.96699 1.46683C2.76699 1.66683 2.66699 1.90016 2.66699 2.16683V4.55016H3.66699V2.16683H12.3337V4.55016H13.3337V2.16683C13.3337 1.90016 13.2337 1.66683 13.0337 1.46683C12.8337 1.26683 12.6003 1.16683 12.3337 1.16683H3.66699ZM7.50033 3.71683V9.90016L5.50033 7.90016L4.78366 8.61683L8.00033 11.8335L11.217 8.61683L10.5003 7.90016L8.50033 9.90016V3.71683H7.50033Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7524_30488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    fill: "white",
    transform: "matrix(1 0 0 -1 4 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ae7b81c70a5134e499bd066d6d2504bd.svg";
export { ForwardRef as ReactComponent };